import { LRParser } from '@lezer/lr';
import { styleTags, tags } from '@lezer/highlight';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const inf$1 = 163,
  nan$1 = 164,
  Bool$1 = 1,
  Ignoring$1 = 2,
  On$1 = 3,
  GroupLeft$1 = 4,
  GroupRight$1 = 5,
  Offset$1 = 6,
  Atan2$1 = 7,
  Avg$1 = 8,
  Bottomk$1 = 9,
  Count$1 = 10,
  CountValues$1 = 11,
  Group$1 = 12,
  Max$1 = 13,
  Min$1 = 14,
  Quantile$1 = 15,
  LimitK$1 = 16,
  LimitRatio$1 = 17,
  Stddev$1 = 18,
  Stdvar$1 = 19,
  Sum$1 = 20,
  Topk$1 = 21,
  By$1 = 22,
  Without$1 = 23,
  And$1 = 24,
  Or$1 = 25,
  Unless$1 = 26,
  Start$1 = 27,
  End$1 = 28;

// Copyright 2021 The Prometheus Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.


const keywordTokens = {
    inf: inf$1,
    nan: nan$1,
    bool: Bool$1,
    ignoring: Ignoring$1,
    on: On$1,
    group_left: GroupLeft$1,
    group_right: GroupRight$1,
    offset: Offset$1,
};

const specializeIdentifier = (value, stack) => {
    return keywordTokens[value.toLowerCase()] || -1;
};

const contextualKeywordTokens = {
    avg: Avg$1,
    atan2: Atan2$1,
    bottomk: Bottomk$1,
    count: Count$1,
    count_values: CountValues$1,
    group: Group$1,
    max: Max$1,
    min: Min$1,
    quantile: Quantile$1,
    limitk: LimitK$1,
    limit_ratio: LimitRatio$1,
    stddev: Stddev$1,
    stdvar: Stdvar$1,
    sum: Sum$1,
    topk: Topk$1,
    by: By$1,
    without: Without$1,
    and: And$1,
    or: Or$1,
    unless: Unless$1,
    start: Start$1,
    end: End$1,
};

const extendIdentifier = (value, stack) => {
    return contextualKeywordTokens[value.toLowerCase()] || -1;
};

// Copyright 2022 The Prometheus Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.


const promQLHighLight = styleTags({
    LineComment: tags.comment,
    LabelName: tags.labelName,
    StringLiteral: tags.string,
    NumberDurationLiteral: tags.number,
    NumberDurationLiteralInDurationContext: tags.number,
    Identifier: tags.variableName,
    'Abs Absent AbsentOverTime Acos Acosh Asin Asinh Atan Atanh AvgOverTime Ceil Changes Clamp ClampMax ClampMin Cos Cosh CountOverTime DaysInMonth DayOfMonth DayOfWeek DayOfYear Deg Delta Deriv Exp Floor HistogramAvg HistogramCount HistogramFraction HistogramQuantile HistogramSum DoubleExponentialSmoothing Hour Idelta Increase Irate LabelReplace LabelJoin LastOverTime Ln Log10 Log2 MaxOverTime MinOverTime Minute Month Pi PredictLinear PresentOverTime QuantileOverTime Rad Rate Resets Round Scalar Sgn Sin Sinh Sort SortDesc SortByLabel SortByLabelDesc Sqrt StddevOverTime StdvarOverTime SumOverTime Tan Tanh Time Timestamp Vector Year':
        tags.function(tags.variableName),
    'Avg Bottomk Count Count_values Group LimitK LimitRatio Max Min Quantile Stddev Stdvar Sum Topk': tags.operatorKeyword,
    'By Without Bool On Ignoring GroupLeft GroupRight Offset Start End': tags.modifier,
    'And Unless Or': tags.logicOperator,
    'Sub Add Mul Mod Div Atan2 Eql Neq Lte Lss Gte Gtr EqlRegex EqlSingle NeqRegex Pow At': tags.operator,
    UnaryOp: tags.arithmeticOperator,
    '( )': tags.paren,
    '[ ]': tags.squareBracket,
    '{ }': tags.brace,
    '⚠': tags.invalid,
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_Identifier = {__proto__:null,absent_over_time:345, absent:347, abs:349, acos:351, acosh:353, asin:355, asinh:357, atan:359, atanh:361, avg_over_time:363, ceil:365, changes:367, clamp:369, clamp_max:371, clamp_min:373, cos:375, cosh:377, count_over_time:379, days_in_month:381, day_of_month:383, day_of_week:385, day_of_year:387, deg:389, delta:391, deriv:393, exp:395, first_over_time:397, floor:399, histogram_count:401, histogram_fraction:403, histogram_quantile:405, histogram_stddev:407, histogram_stdvar:409, histogram_sum:411, histogram_avg:413, double_exponential_smoothing:415, hour:417, idelta:419, increase:421, info:423, irate:425, label_replace:427, label_join:429, last_over_time:431, ln:433, log10:435, log2:437, mad_over_time:439, max_over_time:441, min_over_time:443, ts_of_first_over_time:445, ts_of_max_over_time:447, ts_of_min_over_time:449, ts_of_last_over_time:451, minute:453, month:455, pi:457, predict_linear:459, present_over_time:461, quantile_over_time:463, rad:465, rate:467, resets:469, round:471, scalar:473, sgn:475, sin:477, sinh:479, sort:481, sort_desc:483, sort_by_label:485, sort_by_label_desc:487, sqrt:489, stddev_over_time:491, stdvar_over_time:493, sum_over_time:495, tan:497, tanh:499, timestamp:501, time:503, vector:505, year:507};
const parser = LRParser.deserialize({
  version: 14,
  states: ":QOYQPOOO(TQPOOOOQO'#C|'#C|O(YQPO'#C{Q(eQQOOOOQO'#De'#DeO(`QPO'#DdOOQO'#F_'#F_O)rQPO'#FdOYQPO'#FaOYQPO'#FcO0vQSO'#FfO1RQQO'#FeOOQO'#Fe'#FeOOQO'#Fy'#FyOOQO'#Df'#DfOOQO'#Dh'#DhOOQO'#Di'#DiOOQO'#Dj'#DjOOQO'#Dk'#DkOOQO'#Dl'#DlOOQO'#Dm'#DmOOQO'#Dn'#DnOOQO'#Do'#DoOOQO'#Dp'#DpOOQO'#Dq'#DqOOQO'#Dr'#DrOOQO'#Ds'#DsOOQO'#Dt'#DtOOQO'#Du'#DuOOQO'#Dv'#DvOOQO'#Dw'#DwOOQO'#Dx'#DxOOQO'#Dy'#DyOOQO'#Dz'#DzOOQO'#D{'#D{OOQO'#D|'#D|OOQO'#D}'#D}OOQO'#EO'#EOOOQO'#EP'#EPOOQO'#EQ'#EQOOQO'#ER'#EROOQO'#ES'#ESOOQO'#ET'#ETOOQO'#EU'#EUOOQO'#EV'#EVOOQO'#EW'#EWOOQO'#EX'#EXOOQO'#EY'#EYOOQO'#EZ'#EZOOQO'#E['#E[OOQO'#E]'#E]OOQO'#E^'#E^OOQO'#E_'#E_OOQO'#E`'#E`OOQO'#Ea'#EaOOQO'#Eb'#EbOOQO'#Ec'#EcOOQO'#Ed'#EdOOQO'#Ee'#EeOOQO'#Ef'#EfOOQO'#Eg'#EgOOQO'#Eh'#EhOOQO'#Ei'#EiOOQO'#Ej'#EjOOQO'#Ek'#EkOOQO'#El'#ElOOQO'#Em'#EmOOQO'#En'#EnOOQO'#Eo'#EoOOQO'#Ep'#EpOOQO'#Eq'#EqOOQO'#Er'#ErOOQO'#Es'#EsOOQO'#Et'#EtOOQO'#Eu'#EuOOQO'#Ev'#EvOOQO'#Ew'#EwOOQO'#Ex'#ExOOQO'#Ey'#EyOOQO'#Ez'#EzOOQO'#E{'#E{OOQO'#E|'#E|OOQO'#E}'#E}OOQO'#FO'#FOOOQO'#FP'#FPOOQO'#FQ'#FQOOQO'#FR'#FROOQO'#FS'#FSOOQO'#FT'#FTOOQO'#FU'#FUOOQO'#FV'#FVOOQO'#FW'#FWOOQO'#FX'#FXOOQO'#FY'#FYOOQO'#FZ'#FZOOQO'#F['#F[QOQPOOO2lQPO'#C}O2qQPO'#DSO(`QPO,59gO2xQQO,59gO4fQPO,59oO4fQPO,59oO4fQPO,59oO4fQPO,59oO4fQPO,59oO;jQPO,5;wO;jQPO,5;zO;{QPO,5<XOOQO,5:O,5:OOOQO,5;y,5;yO<dQQO,5;{O<kQQO,5;}OOQO'#DQ'#DQO>RQPO'#FgO>aQPO,5<QOOQO,5<Q,5<QO>mQPO,5<QOOQO,5<P,5<PO>uQSO'#DOOOQO,59i,59iOOQO,59n,59nO?QQQO,59nOOQO1G/R1G/ROOQO'#DV'#DVO2lQPO'#DWOOQO'#F}'#F}O?[QPO'#F}OYQPO1G/ZOYQPO1G/ZOYQPO1G/ZOYQPO1G/ZOYQPO1G/ZOOQO'#F^'#F^OF]QPO'#F^OFhQSO1G1cOOQO1G1f1G1fOFpQPO'#F_OOQO'#Fo'#FoOOQO1G1s1G1sOF{QPO1G1sOOQO1G1g1G1gOOQO'#Fh'#FhOGQQPO,5<ROGVQPO,5<WOG[QSO1G1lOGgQPO1G1lOOQO1G1l1G1lOOQO,59j,59jOGoQPO,59jOYQPO'#FrOGwQPO1G/YOOQO1G/Y1G/YOHPQPO,59rOOQO,5<i,5<iO!![QQO7+$uO!!lQQO7+$uO!$QQQO7+$uO!$hQQO7+$uO!&PQQO7+$uOOQO,5;x,5;xOOQO7+&}7+&}O!&jQPO7+'SO!&qQPO7+'_OOQO1G1m1G1mOOQO1G1r1G1rO!&vQPO,5<_OOQO,5<_,5<_OOQO7+'W7+'WO!'[QSO7+'WOOQO-E9q-E9qO!'gQSO1G/UO!'rQPO1G/UOOQO1G/U1G/UO!'zQQO,5<^OOQO-E9p-E9pOOQO7+$t7+$tO!(UQPO1G/^OOQO<<Jn<<JnO!/PQPO<<JnOOQO<<Jy<<JyOOQO<<Jr<<JrP!/UQSO'#FsOOQO,5<],5<]OOQO7+$p7+$pO!/^QSO7+$pOOQO-E9o-E9oOOQO7+$x7+$xOOQOAN@YAN@YOOQO<<H[<<H[P!/iQSO'#Fq",
  stateData: "!/q~O$lOSmOS~OWQOXQOYQOZQO[QO]QO^QO_QO`QOaQObQOcQOdQOeQOu^O!Z[O$iVO$jVO$nXO$r_O$s`O$taO$ubO$vcO$wdO$xeO$yfO$zgO${hO$|iO$}jO%OkO%PlO%QmO%RnO%SoO%TpO%UqO%VrO%WsO%XtO%YuO%ZvO%[wO%]xO%^yO%_zO%`{O%a|O%b}O%c!OO%d!PO%e!QO%f!RO%g!SO%h!TO%i!UO%j!VO%k!WO%l!XO%m!YO%n!ZO%o![O%p!]O%q!^O%r!_O%s!`O%t!aO%u!bO%v!cO%w!dO%x!eO%y!fO%z!gO%{!hO%|!iO%}!jO&O!kO&P!lO&Q!mO&R!nO&S!oO&T!pO&U!qO&V!rO&W!sO&X!tO&Y!uO&Z!vO&[!wO&]!xO&^!yO&_!zO&`!{O&a!|O&b!}O&c#OO&d#PO&e#QO&f#RO&g#SO&iWO&jWO&kVO&nZO~O!Z#TO~Of#UOg#UO$n#VO~OU#`OV#YOh#]Oi#^Oj#]Ox#YO{#YO|#YO}#YO!O#ZO!P#ZO!Q#[O!R#[O!S#[O!T#[O!U#[O!V#[O$b#aO&h#_O~O$i#cO$j#cO&k#cOW$WXX$WXY$WXZ$WX[$WX]$WX^$WX_$WX`$WXa$WXb$WXc$WXd$WXe$WXu$WX!Z$WX$i$WX$j$WX$n$WX$r$WX$s$WX$t$WX$u$WX$v$WX$w$WX$x$WX$y$WX$z$WX${$WX$|$WX$}$WX%O$WX%P$WX%Q$WX%R$WX%S$WX%T$WX%U$WX%V$WX%W$WX%X$WX%Y$WX%Z$WX%[$WX%]$WX%^$WX%_$WX%`$WX%a$WX%b$WX%c$WX%d$WX%e$WX%f$WX%g$WX%h$WX%i$WX%j$WX%k$WX%l$WX%m$WX%n$WX%o$WX%p$WX%q$WX%r$WX%s$WX%t$WX%u$WX%v$WX%w$WX%x$WX%y$WX%z$WX%{$WX%|$WX%}$WX&O$WX&P$WX&Q$WX&R$WX&S$WX&T$WX&U$WX&V$WX&W$WX&X$WX&Y$WX&Z$WX&[$WX&]$WX&^$WX&_$WX&`$WX&a$WX&b$WX&c$WX&d$WX&e$WX&f$WX&g$WX&i$WX&j$WX&k$WX&n$WX~Os#gOu#fO&o#iO~O&nZOU$XXV$XXh$XXi$XXj$XXx$XX{$XX|$XX}$XX!O$XX!P$XX!Q$XX!R$XX!S$XX!T$XX!U$XX!V$XX$b$XX$h$XX&h$XX$p$XX$o$XX~O$n#lO~O$p#nO~PYOf#UOg#UOUoaVoahoaioajoaxoa{oa|oa}oa!Ooa!Poa!Qoa!Roa!Soa!Toa!Uoa!Voa$boa$hoa&hoa$poa$ooa~OP#qOQ#rOR#rOW$qPX$qPY$qPZ$qP[$qP]$qP^$qP_$qP`$qPa$qPb$qPc$qPd$qPe$qPu$qP!Z$qP$i$qP$j$qP$n$qP$r$qP$s$qP$t$qP$u$qP$v$qP$w$qP$x$qP$y$qP$z$qP${$qP$|$qP$}$qP%O$qP%P$qP%Q$qP%R$qP%S$qP%T$qP%U$qP%V$qP%W$qP%X$qP%Y$qP%Z$qP%[$qP%]$qP%^$qP%_$qP%`$qP%a$qP%b$qP%c$qP%d$qP%e$qP%f$qP%g$qP%h$qP%i$qP%j$qP%k$qP%l$qP%m$qP%n$qP%o$qP%p$qP%q$qP%r$qP%s$qP%t$qP%u$qP%v$qP%w$qP%x$qP%y$qP%z$qP%{$qP%|$qP%}$qP&O$qP&P$qP&Q$qP&R$qP&S$qP&T$qP&U$qP&V$qP&W$qP&X$qP&Y$qP&Z$qP&[$qP&]$qP&^$qP&_$qP&`$qP&a$qP&b$qP&c$qP&d$qP&e$qP&f$qP&g$qP&i$qP&j$qP&k$qP&n$qP~O$i#zO$j#zO&i#{O&j#{O&k#zO~Ok$POl$PO$iVO$jVO&i$OO&j$OO&kVO~O$p$SO~P(eOx#YOU$VaV$Vah$Vai$Vaj$Va{$Va|$Va}$Va!O$Va!P$Va!Q$Va!R$Va!S$Va!T$Va!U$Va!V$Va$b$Va$h$Va&h$Va$p$Va$o$Va~O!V$TO$]$TO$^$TO$_$TO~O!V$TO$]$TO$^$TO$_$TO$o$WO&o$YO~Os$[Ou#fO$p$ZO~O$o$]O$p$_O~P(eOQ#rOR#rOW$qXX$qXY$qXZ$qX[$qX]$qX^$qX_$qX`$qXa$qXb$qXc$qXd$qXe$qXu$qX!Z$qX$i$qX$j$qX$n$qX$r$qX$s$qX$t$qX$u$qX$v$qX$w$qX$x$qX$y$qX$z$qX${$qX$|$qX$}$qX%O$qX%P$qX%Q$qX%R$qX%S$qX%T$qX%U$qX%V$qX%W$qX%X$qX%Y$qX%Z$qX%[$qX%]$qX%^$qX%_$qX%`$qX%a$qX%b$qX%c$qX%d$qX%e$qX%f$qX%g$qX%h$qX%i$qX%j$qX%k$qX%l$qX%m$qX%n$qX%o$qX%p$qX%q$qX%r$qX%s$qX%t$qX%u$qX%v$qX%w$qX%x$qX%y$qX%z$qX%{$qX%|$qX%}$qX&O$qX&P$qX&Q$qX&R$qX&S$qX&T$qX&U$qX&V$qX&W$qX&X$qX&Y$qX&Z$qX&[$qX&]$qX&^$qX&_$qX&`$qX&a$qX&b$qX&c$qX&d$qX&e$qX&f$qX&g$qX&i$qX&j$qX&k$qX&n$qX~O$i$gO$j$gO&k$gO~O&l$hO&m$iO~O$i#cO$j#cO&k#cO~O$n$jO~Ou$kO~Ou$lO~Os#gOu#fO&o$oO~O$o$pO&o$oO~O$o$rO$p$tO~O$o$]O$p$wO~OS$xOT$xOWzaXzaYzaZza[za]za^za_za`zaazabzaczadzaezauza!Zza$iza$jza$nza$rza$sza$tza$uza$vza$wza$xza$yza$zza${za$|za$}za%Oza%Pza%Qza%Rza%Sza%Tza%Uza%Vza%Wza%Xza%Yza%Zza%[za%]za%^za%_za%`za%aza%bza%cza%dza%eza%fza%gza%hza%iza%jza%kza%lza%mza%nza%oza%pza%qza%rza%sza%tza%uza%vza%wza%xza%yza%zza%{za%|za%}za&Oza&Pza&Qza&Rza&Sza&Tza&Uza&Vza&Wza&Xza&Yza&Zza&[za&]za&^za&_za&`za&aza&bza&cza&dza&eza&fza&gza&iza&jza&kza&nza~Ox#YOUwqhwqiwqjwq!Owq!Pwq!Qwq!Rwq!Swq!Twq!Uwq!Vwq$bwq$hwq&hwq$pwq$owq~OVwq{wq|wq}wq~P! QOV#YO{#YO|#YO}#YO~P! QOV#YOx#YO{#YO|#YO}#YO!O#ZO!P#ZOUwqhwqiwqjwq$bwq$hwq&hwq$pwq$owq~O!Qwq!Rwq!Swq!Twq!Uwq!Vwq~P!!|O!Q#[O!R#[O!S#[O!T#[O!U#[O!V#[O~P!!|OV#YOh#]Oj#]Ox#YO{#YO|#YO}#YO!O#ZO!P#ZO!Q#[O!R#[O!S#[O!T#[O!U#[O!V#[O~OUwqiwq$bwq$hwq&hwq$pwq$owq~P!%OO&l$yO~P;jO$p${O~O!V$TO$]$TO$^$TO$_$TO$o$ga&o$ga~Os#gOu#fO&o$|O~Os%OOu#fO$p%PO~O$o%QO$p%PO~O$o$fa$p$fa~P(eO$n#lOWziXziYziZzi[zi]zi^zi_zi`ziazibziczidzieziuzi!Zzi$izi$jzi$rzi$szi$tzi$uzi$vzi$wzi$xzi$yzi$zzi${zi$|zi$}zi%Ozi%Pzi%Qzi%Rzi%Szi%Tzi%Uzi%Vzi%Wzi%Xzi%Yzi%Zzi%[zi%]zi%^zi%_zi%`zi%azi%bzi%czi%dzi%ezi%fzi%gzi%hzi%izi%jzi%kzi%lzi%mzi%nzi%ozi%pzi%qzi%rzi%szi%tzi%uzi%vzi%wzi%xzi%yzi%zzi%{zi%|zi%}zi&Ozi&Pzi&Qzi&Rzi&Szi&Tzi&Uzi&Vzi&Wzi&Xzi&Yzi&Zzi&[zi&]zi&^zi&_zi&`zi&azi&bzi&czi&dzi&ezi&fzi&gzi&izi&jzi&kzi&nzi~O&l%TO~Os#gOu#fO~Os%OOu#fO$p%UO~Os%OOu#fO~O",
  goto: "){$rPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP$s%P%]%cP%lP%|$sP&V&^PPPPPPPPPPP$s&h&tP&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t&t$s'Q'Z$s$s$s$s'j$s'v(V(_PPP(V$sP(fP(i(o(uPPPPP(|PPP)le^OXY#V#u#v#w#x#y$]eROXY#V#u#v#w#x#y$]Q#WRR#p#XQ#m#UQ$`#rR%S$xQ#hZQ$[#lU$m$W$p$}V%O$r%Q%VQ#XRQ#bUR#p#WZ#t#Y#Z#[#]#^Y#s#Y#Z#[#]#^R$a#teUOXY#V#u#v#w#x#y$]eTOXY#V#u#v#w#x#y$]Q#|#_Q#}#`R$z$id^OXY#V#u#v#w#x#y$]R$Q#aeYOXY#V#u#v#w#x#y$]d]OXY#V#u#v#w#x#y$]R#k[Q#jZV$n$W$p$}Q$U#gT$V#h$mR$R#aQ$s$[R%R$sQ$^#oR$v$^S$X#h#jR$q$XQSOQ#dXQ#eYQ#o#VQ$b#uQ$c#vQ$d#wQ$e#xQ$f#yR$u$]Q#u#YQ#v#ZQ#w#[Q#x#]R#y#^",
  nodeNames: "⚠ Bool Ignoring On GroupLeft GroupRight Offset Atan2 Avg Bottomk Count CountValues Group Max Min Quantile LimitK LimitRatio Stddev Stdvar Sum Topk By Without And Or Unless Start End LineComment PromQL AggregateExpr AggregateOp AggregateModifier GroupingLabels LabelName QuotedLabelName StringLiteral FunctionCallBody BinaryExpr Pow BoolModifier MatchingModifierClause Mul Div Mod Add Sub Eql Gte Gtr Lte Lss Neq FunctionCall FunctionIdentifier AbsentOverTime Identifier Absent Abs Acos Acosh Asin Asinh Atan Atanh AvgOverTime Ceil Changes Clamp ClampMax ClampMin Cos Cosh CountOverTime DaysInMonth DayOfMonth DayOfWeek DayOfYear Deg Delta Deriv Exp FirstOverTime Floor HistogramCount HistogramFraction HistogramQuantile HistogramStdDev HistogramStdVar HistogramSum HistogramAvg DoubleExponentialSmoothing Hour Idelta Increase Info Irate LabelReplace LabelJoin LastOverTime Ln Log10 Log2 MadOverTime MaxOverTime MinOverTime TsOfFirstOverTime TsOfMaxOverTime TsOfMinOverTime TsOfLastOverTime Minute Month Pi PredictLinear PresentOverTime QuantileOverTime Rad Rate Resets Round Scalar Sgn Sin Sinh Sort SortDesc SortByLabel SortByLabelDesc Sqrt StddevOverTime StdvarOverTime SumOverTime Tan Tanh Timestamp Time Vector Year MatrixSelector NumberDurationLiteralInDurationContext NumberDurationLiteral OffsetExpr ParenExpr SubqueryExpr UnaryExpr UnaryOp VectorSelector LabelMatchers UnquotedLabelMatcher MatchOp EqlSingle EqlRegex NeqRegex QuotedLabelMatcher StepInvariantExpr At AtModifierPreprocessors MetricName",
  maxTerm: 261,
  nodeProps: [
    ["group", -12,31,37,39,54,139,141,142,143,144,145,147,155,"Expr"]
  ],
  propSources: [promQLHighLight],
  skippedNodes: [0,29],
  repeatNodeCount: 3,
  tokenData: "4k~RwX^#lpq#lqr$ars$tst&luv'Twx'Yxy({yz)Qz{)V{|)[|})c}!O)h!O!P)o!P!Q*u!Q!R*z!R![+u![!]1O!^!_1z!_!`2X!`!a2n!b!c2{!c!}3Q!}#O3h#P#Q3m#Q#R3r#R#S3Q#S#T3w#T#o3Q#o#p4a#q#r4f#y#z#l$f$g#l#BY#BZ#l$IS$I_#l$I|$JO#l$JT$JU#l$KV$KW#l&FU&FV#l~#qY$l~X^#lpq#l#y#z#l$f$g#l#BY#BZ#l$IS$I_#l$I|$JO#l$JT$JU#l$KV$KW#l&FU&FV#l~$dQ!_!`$j#r#s$o~$oO!V~~$tO$_~~$yWu~OY$tZr$trs%cs#O$t#O#P%h#P;'S$t;'S;=`&f<%lO$t~%hOu~~%kRO;'S$t;'S;=`%t;=`O$t~%yXu~OY$tZr$trs%cs#O$t#O#P%h#P;'S$t;'S;=`&f;=`<%l$t<%lO$t~&iP;=`<%l$t~&qSm~OY&lZ;'S&l;'S;=`&}<%lO&l~'QP;=`<%l&l~'YO}~~'_Wu~OY'YZw'Ywx%cx#O'Y#O#P'w#P;'S'Y;'S;=`(u<%lO'Y~'zRO;'S'Y;'S;=`(T;=`O'Y~(YXu~OY'YZw'Ywx%cx#O'Y#O#P'w#P;'S'Y;'S;=`(u;=`<%l'Y<%lO'Y~(xP;=`<%l'Y~)QO$n~~)VO$p~~)[O{~R)cO&jP!OQ~)hO$o~R)oO&iP!PQ~)rP!Q![)u~)zS&k~!Q![)u!g!h*W#R#S)o#X#Y*W~*ZR{|*d}!O*d!Q![*j~*gP!Q![*j~*oQ&k~!Q![*j#R#S*d~*zO|~~+P[&k~!O!P)o!Q![+u!g!h*W#R#S,m#W#X-X#X#Y*W#[#]-p#a#b.U#g#h.x#k#l/Z#l#m0d#m#n/u~+zZ&k~!O!P)o!Q![+u!g!h*W#R#S,m#W#X-X#X#Y*W#[#]-p#a#b.U#g#h.x#k#l/Z#m#n/u~,pP!Q![,s~,xT&k~!O!P)o!Q![,s!g!h*W#R#S,m#X#Y*W~-^P&k~!Q![-a~-dS!Q![-a#[#]-p#a#b.U#g#h.x~-uP&k~!Q![-x~-{R!Q![-x#a#b.U#g#h.x~.ZQ&k~!Q![.a#g#h.s~.dR!Q![.a#a#b.m#g#h.x~.pP#g#h.s~.xO&k~~.}P&k~!Q![/Q~/TQ!Q![/Q#a#b.m~/`P&k~!Q![/c~/fT!Q![/c#W#X-X#[#]-p#a#b.U#g#h.x~/zP&k~!Q![/}~0QU!Q![/}#W#X-X#[#]-p#a#b.U#g#h.x#k#l/Z~0gR!Q![0p!c!i0p#T#Z0p~0uR&k~!Q![0p!c!i0p#T#Z0pV1VT&mS!ZR!Q![1f![!]1f!c!}1f#R#S1f#T#o1fR1kT!ZR!Q![1f![!]1f!c!}1f#R#S1f#T#o1f~2PP!U~!_!`2S~2XO!T~~2^Q$]P!_!`2d#r#s2iQ2iO!QQ~2nO$^~~2sP!S~!_!`2v~2{O!R~~3QO$b~V3XT!ZRsS!Q![3Q![!]1f!c!}3Q#R#S3Q#T#o3Q~3mO&h~~3rO&l~~3wOx~~3zTO#S3w#S#T%c#T;'S3w;'S;=`4Z<%lO3w~4^P;=`<%l3w~4fO&n~~4kO&o~",
  tokenizers: [0, 1, 2],
  topRules: {"PromQL":[0,30],"MetricName":[1,158]},
  specialized: [{term: 57, get: (value, stack) => (specializeIdentifier(value) << 1), external: specializeIdentifier},{term: 57, get: (value, stack) => (extendIdentifier(value) << 1) | 1, external: extendIdentifier, extend: true},{term: 57, get: (value) => spec_Identifier[value] || -1}],
  tokenPrec: 0
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const inf = 163,
  nan = 164,
  Bool = 1,
  Ignoring = 2,
  On = 3,
  GroupLeft = 4,
  GroupRight = 5,
  Offset = 6,
  Atan2 = 7,
  Avg = 8,
  Bottomk = 9,
  Count = 10,
  CountValues = 11,
  Group = 12,
  Max = 13,
  Min = 14,
  Quantile = 15,
  LimitK = 16,
  LimitRatio = 17,
  Stddev = 18,
  Stdvar = 19,
  Sum = 20,
  Topk = 21,
  By = 22,
  Without = 23,
  And = 24,
  Or = 25,
  Unless = 26,
  Start = 27,
  End = 28,
  LineComment = 29,
  PromQL = 30,
  AggregateExpr = 31,
  AggregateOp = 32,
  AggregateModifier = 33,
  GroupingLabels = 34,
  LabelName = 35,
  QuotedLabelName = 36,
  StringLiteral = 37,
  FunctionCallBody = 38,
  BinaryExpr = 39,
  Pow = 40,
  BoolModifier = 41,
  MatchingModifierClause = 42,
  Mul = 43,
  Div = 44,
  Mod = 45,
  Add = 46,
  Sub = 47,
  Eql = 48,
  Gte = 49,
  Gtr = 50,
  Lte = 51,
  Lss = 52,
  Neq = 53,
  FunctionCall = 54,
  FunctionIdentifier = 55,
  AbsentOverTime = 56,
  Identifier = 57,
  Absent = 58,
  Abs = 59,
  Acos = 60,
  Acosh = 61,
  Asin = 62,
  Asinh = 63,
  Atan = 64,
  Atanh = 65,
  AvgOverTime = 66,
  Ceil = 67,
  Changes = 68,
  Clamp = 69,
  ClampMax = 70,
  ClampMin = 71,
  Cos = 72,
  Cosh = 73,
  CountOverTime = 74,
  DaysInMonth = 75,
  DayOfMonth = 76,
  DayOfWeek = 77,
  DayOfYear = 78,
  Deg = 79,
  Delta = 80,
  Deriv = 81,
  Exp = 82,
  FirstOverTime = 83,
  Floor = 84,
  HistogramCount = 85,
  HistogramFraction = 86,
  HistogramQuantile = 87,
  HistogramStdDev = 88,
  HistogramStdVar = 89,
  HistogramSum = 90,
  HistogramAvg = 91,
  DoubleExponentialSmoothing = 92,
  Hour = 93,
  Idelta = 94,
  Increase = 95,
  Info = 96,
  Irate = 97,
  LabelReplace = 98,
  LabelJoin = 99,
  LastOverTime = 100,
  Ln = 101,
  Log10 = 102,
  Log2 = 103,
  MadOverTime = 104,
  MaxOverTime = 105,
  MinOverTime = 106,
  TsOfFirstOverTime = 107,
  TsOfMaxOverTime = 108,
  TsOfMinOverTime = 109,
  TsOfLastOverTime = 110,
  Minute = 111,
  Month = 112,
  Pi = 113,
  PredictLinear = 114,
  PresentOverTime = 115,
  QuantileOverTime = 116,
  Rad = 117,
  Rate = 118,
  Resets = 119,
  Round = 120,
  Scalar = 121,
  Sgn = 122,
  Sin = 123,
  Sinh = 124,
  Sort = 125,
  SortDesc = 126,
  SortByLabel = 127,
  SortByLabelDesc = 128,
  Sqrt = 129,
  StddevOverTime = 130,
  StdvarOverTime = 131,
  SumOverTime = 132,
  Tan = 133,
  Tanh = 134,
  Timestamp = 135,
  Time = 136,
  Vector = 137,
  Year = 138,
  MatrixSelector = 139,
  NumberDurationLiteralInDurationContext = 140,
  NumberDurationLiteral = 141,
  OffsetExpr = 142,
  ParenExpr = 143,
  SubqueryExpr = 144,
  UnaryExpr = 145,
  UnaryOp = 146,
  VectorSelector = 147,
  LabelMatchers = 148,
  UnquotedLabelMatcher = 149,
  MatchOp = 150,
  EqlSingle = 151,
  EqlRegex = 152,
  NeqRegex = 153,
  QuotedLabelMatcher = 154,
  StepInvariantExpr = 155,
  At = 156,
  AtModifierPreprocessors = 157,
  MetricName = 158;

export { Abs, Absent, AbsentOverTime, Acos, Acosh, Add, AggregateExpr, AggregateModifier, AggregateOp, And, Asin, Asinh, At, AtModifierPreprocessors, Atan, Atan2, Atanh, Avg, AvgOverTime, BinaryExpr, Bool, BoolModifier, Bottomk, By, Ceil, Changes, Clamp, ClampMax, ClampMin, Cos, Cosh, Count, CountOverTime, CountValues, DayOfMonth, DayOfWeek, DayOfYear, DaysInMonth, Deg, Delta, Deriv, Div, DoubleExponentialSmoothing, End, Eql, EqlRegex, EqlSingle, Exp, FirstOverTime, Floor, FunctionCall, FunctionCallBody, FunctionIdentifier, Group, GroupLeft, GroupRight, GroupingLabels, Gte, Gtr, HistogramAvg, HistogramCount, HistogramFraction, HistogramQuantile, HistogramStdDev, HistogramStdVar, HistogramSum, Hour, Idelta, Identifier, Ignoring, Increase, Info, Irate, LabelJoin, LabelMatchers, LabelName, LabelReplace, LastOverTime, LimitK, LimitRatio, LineComment, Ln, Log10, Log2, Lss, Lte, MadOverTime, MatchOp, MatchingModifierClause, MatrixSelector, Max, MaxOverTime, MetricName, Min, MinOverTime, Minute, Mod, Month, Mul, Neq, NeqRegex, NumberDurationLiteral, NumberDurationLiteralInDurationContext, Offset, OffsetExpr, On, Or, ParenExpr, Pi, Pow, PredictLinear, PresentOverTime, PromQL, Quantile, QuantileOverTime, QuotedLabelMatcher, QuotedLabelName, Rad, Rate, Resets, Round, Scalar, Sgn, Sin, Sinh, Sort, SortByLabel, SortByLabelDesc, SortDesc, Sqrt, Start, Stddev, StddevOverTime, Stdvar, StdvarOverTime, StepInvariantExpr, StringLiteral, Sub, SubqueryExpr, Sum, SumOverTime, Tan, Tanh, Time, Timestamp, Topk, TsOfFirstOverTime, TsOfLastOverTime, TsOfMaxOverTime, TsOfMinOverTime, UnaryExpr, UnaryOp, Unless, UnquotedLabelMatcher, Vector, VectorSelector, Without, Year, inf, nan, parser };
